/** @jsxImportSource @emotion/react */
import { Box, Typography } from '@mui/material'

import { legendRowMainClass } from './LegendRow.styles'
import { Swatch, SwatchItem } from '../Swatch'

export type LegendRowProps = {
  label: string
  swatch: SwatchItem
  logo?: string
  isTop?: boolean
  isBottom?: boolean
}

export const LegendRow = ({
  label,
  swatch,
  logo,
  isTop = false,
  isBottom = false,
}: LegendRowProps) => {
  // Make sure swatch has a size
  const theSwatch: SwatchItem = { size: 'small', ...swatch }
  return (
    <Box css={legendRowMainClass()}>
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <Swatch item={theSwatch} isTop={isTop} isBottom={isBottom} />
        {logo && (
          <img
            src={logo}
            style={{
              position: 'absolute',
              left: '1px',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '14px',
              height: '14px',
              objectFit: 'contain',
            }}
          />
        )}
      </Box>
      <Typography variant="body2">{label}</Typography>
    </Box>
  )
}
